import { z } from "zod";
import { TObjectBase, TApiObjectBase } from "../base";
import { TTranslationData } from "../common/translation";

export type IRawCustomFieldDataOptions = z.infer<
  typeof TRawCustomFieldDataOptions
>;
export const TRawCustomFieldDataOptions = z.object({
  timeEnabled: z.boolean().optional(),
  dateEnabled: z.boolean().optional(),
  contractorAccess: z.boolean().optional(),
  formula: z.string().optional(),
  collectionID: z.string().optional(),
  standardID: z.string().optional(),
  customDataTypeID: z.string().optional(),
  isMulti: z.boolean().optional(),
  previewFiles: z.boolean().optional(),
  hideParentReference: z.boolean().optional(),
});

export type IRawCustomField = z.infer<typeof TRawCustomField>;
export const TRawCustomField = z
  .object({
    companyID: z.string(),
    dataType: z.string(),
    dataOptions: TRawCustomFieldDataOptions.optional(),
    name: TTranslationData,
  })
  .extend(TObjectBase.shape);

export type IApiCustomField = z.infer<typeof TApiCustomField>;
export const TApiCustomField = z
  .object({
    id: z.string(),
    dataType: z.string(),
    dataOptions: TRawCustomFieldDataOptions.optional(),
    name: TTranslationData,
  })
  .extend(TApiObjectBase.shape);

export const TRawCollectionCustomField = z
  .object({
    dataType: z.string(),
    dataOptions: TRawCustomFieldDataOptions.optional(),
    name: TTranslationData,
    requiredFieldValuesToDisplay: z.record(z.array(z.any())).nullish(),
    deprecated: z.boolean().nullish(),
  })
  .extend(TObjectBase.shape);
export type IRawCollectionCustomField = z.infer<
  typeof TRawCollectionCustomField
>;

export const TApiCollectionCustomField = z
  .object({
    dataType: z.string(),
    dataOptions: TRawCustomFieldDataOptions.optional(),
    name: TTranslationData,
  })
  .extend(TApiObjectBase.shape);
export type IApiCollectionCustomField = z.infer<
  typeof TApiCollectionCustomField
>;
